// ─────────────────────────────────────────────────────────────────────────────
// Indicador global "DATOS DE PRUEBA".
//
// Existe por un incidente concreto: en la VM del demo `VITE_USE_MOCK=true` y la app mostraba las
// 5 encuestas ficticias de `mockSurveys` sin ninguna señal visible, así que se creyó que eran
// datos del cliente. Con este badge nunca más se confunde mock con datos reales.
//
// Por qué basta con leer USE_MOCK: tras la limpieza del fallback silencioso (ver MOCK_FALLBACK.md),
// los datos mock SOLO se sirven dentro de `if (USE_MOCK)` en los queryFn. Un error de red ya no
// degrada a mock — muestra un error visible. Por tanto `USE_MOCK === true` es exactamente la
// condición "alguna vista puede estar sirviendo datos ficticios".
//
// D-8 (Fase 3) — Segunda condición: `VITE_RECOGNITION_MOCK`. Mientras dura el bloqueo B-1, el
// módulo de Reconocimiento se sirve de un mock dentro del propio frontend. Es exactamente el
// escenario que hizo nacer este badge (datos ficticios sin señal visible que se tomaron por datos
// del cliente), así que el mismo aviso aplica. Ver `src/api/recognition/mock/index.ts`.
// ─────────────────────────────────────────────────────────────────────────────

import { useTranslation } from 'react-i18next';
import { USE_MOCK } from '@/api/client';

const RECOGNITION_MOCK = import.meta.env.VITE_RECOGNITION_MOCK === 'true';

export function MockDataBadge() {
  const { t } = useTranslation();
  if (!USE_MOCK && !RECOGNITION_MOCK) return null;
  return (
    <div className="mock-data-badge" role="status" title={t('common.mockDataHint')}>
      <i className="fas fa-flask" aria-hidden="true" /> {t('common.mockData')}
    </div>
  );
}
